import React from 'react';
import { Shield, Lock, Eye, UserCheck, Brain, Zap } from 'lucide-react';

const Trust = () => {
  return (
    <div className="mx-auto max-w-4xl px-6 py-12 md:px-12">
      <h1 className="animate-fade-in mb-8 text-4xl font-bold md:text-5xl">
        Building Trust Through Transparency
      </h1>

      <div className="animate-fade-in space-y-16" style={{ animationDelay: '200ms' }}>
        <section>
          <div className="mb-4 flex items-center gap-3">
            <Shield className="h-6 w-6" />
            <h2 className="text-2xl font-bold">Our Commitment</h2>
          </div>
          <p className="mb-6 text-lg text-gray-400">
            We're building hebe with a fundamental belief: your digital companion should be
            trustworthy, transparent, and aligned with your interests. Our mission is to create
            technology that enhances your life while respecting your privacy and agency.
          </p>
        </section>

        <section>
          <div className="mb-4 flex items-center gap-3">
            <Lock className="h-6 w-6" />
            <h2 className="text-2xl font-bold">Privacy by Design</h2>
          </div>
          <p className="mb-6 text-lg text-gray-400">
            Privacy isn't an afterthought—it's built into hebe's core. Your data remains under your
            control, encrypted, and never used for purposes you haven't explicitly authorized. We
            believe in giving you the power to decide what information you share and how it's used.
          </p>
        </section>

        <section>
          <div className="mb-4 flex items-center gap-3">
            <Eye className="h-6 w-6" />
            <h2 className="text-2xl font-bold">Transparency</h2>
          </div>
          <p className="mb-6 text-lg text-gray-400">
            We're committed to being clear about how hebe works, what data it uses, and how it makes
            decisions. You'll always know what's happening with your information and have control
            over your digital experience.
          </p>
        </section>

        <section>
          <div className="mb-4 flex items-center gap-3">
            <UserCheck className="h-6 w-6" />
            <h2 className="text-2xl font-bold">User Control</h2>
          </div>
          <p className="mb-6 text-lg text-gray-400">
            hebe is designed to empower, not replace. You maintain full control over your digital
            environment, with the ability to customize, override, or disable any feature. Your
            companion adapts to your preferences, not the other way around.
          </p>
        </section>

        <section>
          <div className="mb-4 flex items-center gap-3">
            <Brain className="h-6 w-6" />
            <h2 className="text-2xl font-bold">Ethical AI</h2>
          </div>
          <p className="mb-6 text-lg text-gray-400">
            Our AI is developed with strong ethical principles, ensuring fairness, accountability,
            and transparency. We're committed to preventing bias and maintaining high standards for
            responsible AI development.
          </p>
        </section>

        <section>
          <div className="mb-4 flex items-center gap-3">
            <Zap className="h-6 w-6" />
            <h2 className="text-2xl font-bold">Future Vision</h2>
          </div>
          <p className="mb-6 text-lg text-gray-400">
            We're building hebe for a future where technology serves humanity, not the other way
            around. Our goal is to create a digital companion that enhances your capabilities while
            respecting your autonomy and privacy.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Trust;
